import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SectionLabel, Reveal } from "./ui";

const values = [
  { n: "01", title: "Built for attention", text: "Every cut, visual and sound choice has a purpose." },
  { n: "02", title: "Content-first thinking", text: "We don't just make footage look good. We make the message easier to watch." },
  { n: "03", title: "One creative partner", text: "Editing, motion, repurposing and visual content under one roof." },
  { n: "04", title: "Your brand, not ours", text: "Your content should feel recognizable, not like another template." },
];

export const WhyUs = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="why" className="relative py-24 md:py-32 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <SectionLabel>Why Us</SectionLabel>
          <Reveal>
            <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight">
              More than just an editor.
            </h2>
          </Reveal>
        </div>

        <div className="border-t" style={{ borderColor: "var(--border-color)" }}>
          {values.map((v, i) => (
            <motion.div
              key={v.n}
              onMouseEnter={() => setActive(i)}
              onClick={() => setActive(i)}
              className="group relative border-b cursor-default"
              style={{ borderColor: "var(--border-color)" }}
              data-testid={`why-item-${i}`}
            >
              {/* active accent bar */}
              <motion.span
                className="absolute left-0 top-0 bottom-0 w-[2px]"
                style={{ background: "var(--accent-color)" }}
                animate={{ scaleY: active === i ? 1 : 0 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              />
              <div className="grid md:grid-cols-[auto_1fr_1.2fr] gap-4 md:gap-10 items-center py-8 md:py-10 pl-5 md:pl-8">
                <span
                  className="font-heading text-lg font-medium transition-colors duration-300"
                  style={{ color: active === i ? "var(--accent-color)" : "var(--text-secondary)" }}
                >
                  {v.n}
                </span>
                <h3
                  className="font-heading text-2xl md:text-4xl font-medium tracking-tight transition-colors duration-300"
                  style={{ color: active === i ? "var(--text-primary)" : "var(--text-secondary)" }}
                >
                  {v.title}
                </h3>
                <div className="hidden md:block overflow-hidden">
                  <AnimatePresence mode="wait">
                    {active === i && (
                      <motion.p
                        key={v.n}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.35 }}
                        className="text-base leading-relaxed"
                        style={{ color: "var(--text-secondary)" }}
                      >
                        {v.text}
                      </motion.p>
                    )}
                  </AnimatePresence>
                </div>
                <p className="md:hidden text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                  {v.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
